import { PUR2040_R01Dto } from "./Dto_PUR2040_R01";
import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PUR2040_R01Filter } from "./Store_PUR2040_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PUR2040_R01`;

const getParams = (filter: Partial<PUR2040_R01Filter>, listLength?: number, refetchListLength?: number) => {
    return {
        compCd: filter.compCd || undefined,
        customCd: filter.customCd || undefined,
        itemCd: filter.itemCd || undefined,
        startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
        endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
        listLength: listLength || undefined,
        refetchListLength: refetchListLength || undefined,
    };
};

// 매입내역 조회
export const getPUR2040_R01List = async (option: string = '', params: Partial<PUR2040_R01Filter>, listLength: number = 0, refetchListLength?: number) => {
    const url = option ? `${baseUrl}/${option}` : `${baseUrl}/`;
    return await getData<ResponseDto<PUR2040_R01Dto[]>>(url, { params: getParams(params, listLength, refetchListLength) });
};

// 매입내역 전체 건수 조회
export const getPUR2040_R01AllCount = async (params: Partial<PUR2040_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
};

// 매입내역 엑셀 다운로드
export const exportPUR2040_R01Excel = async (option: string = '', params: Partial<PUR2040_R01Filter>) => {
    const url = option ? `${baseUrl}/excel/${option}` : `${baseUrl}/excel/`;

    const requestParams = {
        compCd: params?.compCd || undefined,
        customCd: params?.customCd || undefined,
        itemCd: params?.itemCd || undefined,
        startDate: params?.dateRange?.from ? formatDate(params.dateRange.from) : undefined,
        endDate: params?.dateRange?.to ? formatDate(params.dateRange.to) : undefined,
    };
    return await getData<ResponseDto<string>>(url, { params: requestParams });
};
